// @Version: 1.0.3
import { Injectable } from '@angular/core';
import { IErrorCodes } from 'src/app/shared/services/errorMessages/error-messages.model';
import { ErrorMessagesService } from 'src/app/shared/services/errorMessages/error-messages.service';
import { ICON, IRateItem, MATERIAL } from './rating.model';
import { COLOR } from '../field-item.model';
import { TRANSLATE_PATH } from 'src/app/shared/shared.model';



@Injectable()
export class FieldItemRatingService {

   private list_: IRateItem[] = [];

   private required_: boolean = false;
   private errorCodes_: IErrorCodes = {} as IErrorCodes;
   private minNumber_: number = -1;
   private maxNumber_: number = -1;

   get minNumber (): number {
      return this.minNumber_;
   }
   set minNumber (value: number) {
      this.minNumber_ = value;
   }

   get maxNumber (): number {
      return this.maxNumber_;
   }
   set maxNumber (value: number) {
      this.maxNumber_ = value;
   }

   get required (): boolean {
      return this.required_;
   }
   set required (value: boolean) {
      this.required_ = value;
   }

   get ratingButtons (): IRateItem[] {
      return this.list_;
   }

   get errorCodes (): IErrorCodes {
      return this.errorCodes_;
   }

   constructor (private sErrorMessage: ErrorMessagesService) { }

   public createErrorMessages (errorMessage: string): boolean {
      this.errorCodes_ = this.sErrorMessage.setErrorCodes(errorMessage, TRANSLATE_PATH.FIELD_ITEM_ERROR);
      return true;
   }

   public createRatingButtons (iconName: string): boolean {
      const ratingButtons: IRateItem[] = [];
      if (iconName.length == 0 || iconName == '') return false;
      
      let splitAttribute: string[] = MATERIAL[iconName as keyof typeof MATERIAL].split(';');
   
      const result: number = Math.trunc(this.maxNumber / splitAttribute.length);
      let laps = this.maxNumber % splitAttribute.length;
      
      for (let i = 0; i < splitAttribute.length; i++) {
         if (laps <= 0) {
            for (let j = 0; j < result; j++) {
               ratingButtons.push({ 
                  icon: splitAttribute[i] ,
                  color: iconName == ICON.NUMBER ? COLOR.ACCENT : COLOR.DISABLED
               });
            }
         }
         
         if (laps > 0) {
            for (let j = 0; j < result + 1; j++) {
               ratingButtons.push({
                  icon: splitAttribute[i] ,
                  color: iconName == ICON.NUMBER ? COLOR.ACCENT : COLOR.DISABLED
               });
            }
            laps--;
         }
      }

      this.list_ = ratingButtons;
      return true;
   }

   public reset (): void {
      this.minNumber_ = 0;
      this.maxNumber_ = 0;
      this.required_ = false;
      this.list_ = [];
      this.errorCodes_ = {} as IErrorCodes;
   }
}